import { useEffect, useReducer } from 'react';
import {
  FEATURE_FLAG_KEY,
  setFeatureFlagsIndexedDb,
} from '../../modules/FeatureFlags';
import { localStorage } from '../../modules/Browser/localStorage';
import {
  INITIALIZED,
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAIL,
  STATUS,
  RESET,
} from './constants';
import { State, Action } from './types';

const initialState: State = {
  error: null,
  status: STATUS.IDLE,
  featureFlags: undefined,
  isInitializedFromBrowserStorage: false,
};

function reducer(state: State, action: Action) {
  switch (action.type) {
    case INITIALIZED:
      return {
        ...state,
        featureFlags: action.payload.featureFlags,
        isInitializedFromBrowserStorage: true,
      };
    case FETCH:
      return { ...state, status: STATUS.LOADING, error: null };
    case FETCH_SUCCESS:
      return {
        ...state,
        status: STATUS.SUCCESS,
        featureFlags: action.payload.featureFlags,
      };
    case FETCH_FAIL:
      return { ...state, status: STATUS.FAIL, error: action.payload.error };
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export function useFeatureFlags() {
  const [state, dispatch] = useReducer(reducer, initialState);

  /** fetch and set feature flags in browser storage and state */
  async function handleSetFeatureFlags() {
    try {
      dispatch({ type: FETCH });
      const {
        error: newError,
        featureFlags: newFeatureFlags,
      } = await setFeatureFlagsIndexedDb();
      if (newFeatureFlags) {
        dispatch({
          type: FETCH_SUCCESS,
          payload: { featureFlags: newFeatureFlags },
        });
      }
      if (newError) {
        dispatch({
          type: FETCH_FAIL,
          payload: { error: newError },
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_FAIL,
        payload: { error: err.message },
      });
    }
  }

  /**
   * on page load, see if there are feature flags stored in browser storage
   * and set them into state
   */
  useEffect(() => {
    localStorage.getItem(FEATURE_FLAG_KEY).then(featureFlagsStored => {
      dispatch({
        type: INITIALIZED,
        payload: { featureFlags: featureFlagsStored || null },
      });
    });
  }, []);

  function resetFeatureFlags() {
    dispatch({ type: RESET });
  }
  return { handleSetFeatureFlags, state, resetFeatureFlags };
}
